export default __webpack_public_path__ + "static/media/body_knightsarmor.6fb91486.png";